import { createGlobalStyle } from 'styled-components';

import { customScrollbar, media } from './style';
import zIndex from './zIndex';

export const GlobalStyles = createGlobalStyle`
  :root {
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  
  html{
    font-size: 12px;
    font-family: var(--font-display);
    -webkit-text-size-adjust: none;
    touch-action: none;
    ${media.tablet}{
      font-size: 10px;
    }
  }

  body {
    background-color: ${(props) => props.theme.colors.gray100};
    color: ${(props) => props.theme.colors.gray800};
    padding: 0;
    margin: 0;
    /* override radix-themes */
    .radix-themes {
      /* fix overflow-wrap from break-word to normal */
      overflow-wrap: normal;
      /* override default font family */
      --default-font-family: var(--font-display);
    }
  }
  
  .pc-tablet-only {
    display: block;
    ${media.mobile} {
      display: none;
    }
  }
  .tablet-mobile-only{
    display: none;
    ${media.tablet}{
      display:block;
    }
  }
  .mobile-only {
    display: none;
    ${media.mobile} {
      display: block;
    }
  }
  
  #toast-layer {
    position: fixed;
    z-index: ${zIndex.toast};
  }
  #preview-layer {  
    position: fixed;
    z-index: ${zIndex.preview};
  }
  #tooltip-layer {
    position: fixed;
    pointer-events: none;
    user-select: none;
    z-index: ${zIndex.tooltip};
  }
  #page-loading-layer {
    position: fixed;
    z-index: ${zIndex.pageLoading};
  }
  #syncly-popup-layer {
    position: fixed;
    z-index: ${zIndex.popup};
  }
  #dropdown-layer {
    position: fixed;
    z-index: ${zIndex.dropdown};
  }
  #modal-layer {
    position: fixed;
    z-index: ${zIndex.modal};
  }
  #widget-layer {
    position: fixed;
    z-index: ${zIndex.widget};
  }
  #detail-modal-layer {  
    position: fixed;
    z-index: ${zIndex.detailModal};
  }
  #content-modal-layer {  
    position: fixed;
    z-index: ${zIndex.contentModal};
  }
  #hidden-layer {
    position: fixed;
    z-index: ${zIndex.hidden};
  }

  .highlight {
    display: inline-block;
    padding: 2px 0px;
    border-radius: 2px;
    background-color: ${(props) => props.theme.colors.primary100};
    color: ${(props) => props.theme.colors.FL100};
    font-weight: 600;
  }

  .topic-select-tree {
    .ant-select-tree-treenode {
      align-items: center;
    }
    .ant-select-tree-switcher {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ant-select-tree-checkbox {
      display: flex;
      align-items: center;
      .ant-select-tree-checkbox-inner {
        top: 2px;
      }
    }
    .ant-select-tree-node-content-wrapper {
      display: flex;
      align-items: center;
    }
  }
  
  .ant-select .ant-select-arrow{
    color: ${(props) => props.theme.colors.gray600};
  }
  .ant-select-dropdown {
    border-radius: 8px !important;
    .ant-select-item {
      border-radius: 4px !important;
    }
  }

  .ant-table {
    scrollbar-color: ${(props) => props.theme.colors.gray300} ${(props) =>
      props.theme.colors.gray200} !important;
  }

  .ant-picker-dropdown .ant-picker-panel-container {
    border-radius: 8px !important;
  }

  html,
  body,
  #root {
    scrollbar-gutter: stable;
  }

  html,
  body,
  [data-slot='sidebar-content'],
  [data-slot='scroll-area'],
  [data-slot='scroll-area-viewport'],
  .overflow-auto,
  .overflow-x-auto,
  .overflow-y-auto {
    ${customScrollbar};
    scrollbar-gutter: stable;
  }
`;
